// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___17G17","inactive":"index-module__inactive___uOj9b"};